import { render, staticRenderFns } from "./DatabasesMigrationsList.vue?vue&type=template&id=39a858eb&"
import script from "./DatabasesMigrationsList.vue?vue&type=script&lang=ts&"
export * from "./DatabasesMigrationsList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports